import { gsap } from 'gsap/all'

const el = {
  cover: document.querySelector<HTMLElement>('.cover'),
  footerContainer: document.querySelector<HTMLElement>('.footer__container'),
  main: document.querySelector<HTMLElement>('.main'),
  navigationLinks: document.querySelectorAll<HTMLElement>('[data-navigation-link]'),
}

export const pageTransitions = {
  init: () => {
    el.navigationLinks.forEach((link) => {
      link.addEventListener('click', pageTransitions.handleLinkClick)
    })

    // handling page restore for mobile iOS - without this back/forward buttons won't reload pages' js
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        window.location.reload()
      }
    })

    if (!sessionStorage.getItem('pageLoaded')) {
      sessionStorage.setItem('transitionType', 'transform')
      pageTransitions.handleFirstPageLoad()
    } else {
      pageTransitions.handlePageReveal()
    }
  },

  handleLinkClick: (event) => {
    event.preventDefault()

    const resetHeaderLinks = () => {
      document.querySelectorAll<HTMLElement>('.header__navigation-link--selected').forEach((link) => {
        link.classList.remove('header__navigation-link--selected')
      })

      if (event.target.classList.contains('header__navigation-link')) {
        event.target.classList.add('header__navigation-link--selected')
      }
    }

    const resetSubnavigationLinks = () => {
      document.querySelectorAll<HTMLElement>('.subnavigation__link--selected').forEach((link) => {
        link.classList.remove('subnavigation__link--selected')
      })

      if (event.target.classList.contains('subnavigation__link')) {
        event.target.classList.add('subnavigation__link--selected')
      }
    }

    const resetLinks = () => {
      resetHeaderLinks()
      resetSubnavigationLinks()
    }

    const transitionType = event.currentTarget.getAttribute('data-transition') // sessionStorage.getItem('transitionType')

    if (transitionType === 'transform') {
      gsap.timeline().to(
        [el.main, el.footerContainer],
        {
          duration: 0.456,
          ease: 'power4.in',
          opacity: 0,
          overwrite: true,
          y: -32,
          onStart: resetLinks,
          onComplete: () => {
            sessionStorage.setItem('transitionType', 'transform')
            window.location.href = event.target.getAttribute('href')
          },
        },
        0
      )
    }

    if (transitionType === 'fade') {
      gsap
        .timeline()
        // .to(window, { duration: 0.334, scrollTo: 0 }, 0)
        .to(
          [el.main, el.footerContainer],
          {
            duration: 0.234,
            opacity: 0,
            onStart: resetLinks,
            onComplete: () => {
              sessionStorage.setItem('transitionType', 'fade')
              window.location.href = event.target.getAttribute('href')
            },
          },
          0.1
        )
    }

    if (transitionType === 'none') {
      resetSubnavigationLinks()
      setTimeout(() => {
        sessionStorage.setItem('transitionType', 'none')
        window.location.href = event.target.getAttribute('href')
      }, 300)
    }
  },

  handleFirstPageLoad: () => {
    gsap
      .timeline()
      .set([el.main, el.footerContainer], { y: 56 }, 0)
      .to(
        el.cover,
        {
          duration: 0.456,
          ease: 'power4.inOut',
          scaleY: 0,
          transformOrigin: '0 0',
          onComplete: () => {
            sessionStorage.setItem('pageLoaded', 'true')
          },
        },
        0.4
      )
      .to(
        [el.main, el.footerContainer],
        {
          clearProps: 'all',
          duration: 1,
          ease: 'power4.out',
          opacity: 1,
          stagger: 0.21,
          y: 0,
        },
        0.5
      )
  },

  handlePageReveal: () => {
    let transitionType = sessionStorage.getItem('transitionType')
    const hasCheckoutFooter = document.querySelector<HTMLElement>('.checkout-footer')

    if (hasCheckoutFooter) {
      transitionType = 'none'
    }

    gsap.set(el.cover, { display: 'none' })

    if (transitionType === 'transform') {
      gsap
        .timeline()
        .set(
          [el.main, el.footerContainer],
          {
            opacity: 0,
            y: 43,
          },
          0
        )
        .to(
          [el.main, el.footerContainer],
          {
            clearProps: 'all',
            duration: 0.567,
            ease: 'power4.out',
            opacity: 1,
            stagger: 0.21,
            y: 0,
          },
          0.1
        )
        .to(
          el.cover,
          {
            duration: 0.456,
            ease: 'power4.inOut',
            scaleY: 0,
            transformOrigin: '0 0',
          },
          0.1
        )
    }

    if (transitionType === 'fade') {
      gsap.timeline().set([el.main, el.footerContainer], { opacity: 0 }, 0).to(
        [el.main, el.footerContainer],
        {
          clearProps: 'all',
          duration: 0.567,
          ease: 'power4.out',
          opacity: 1,
          // onStart: () => { // ?
          //   const selectedClass = 'header__navigation-link--selected'
          //   const transitionClass = 'header__navigation-link--no-transition'
          //   const selectedLink = document.querySelector<HTMLElement>(`.${selectedClass}`)

          //   if (selectedLink) {
          //     selectedLink.classList.add(transitionClass)
          //     selectedLink.classList.remove(selectedClass)
          //     setTimeout(() => {
          //       selectedLink.classList.remove(transitionClass)
          //       selectedLink.classList.add(selectedClass)
          //     }, 1)
          //   }
          // },
        },
        0
      )
    }

    if (transitionType === 'none') {
      gsap.set(el.cover, { display: 'none' })
    }
  },
}
